import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import config from '@/config'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown} from 'element-ui'
import NavbarScrollMixin from '@/mixins/navbarScrollMixin'
import '@/mixins/index'
import './utils/prototypes'
import { } from '@/utils/types'
import { customConfirm } from '@/utils/customConfirm';

import '@/styles/index.scss'
import '@/styles/indexArgon.scss'

import AsyncComputed from 'vue-async-computed'
// import SignalHub from '@/api/signalHub'
import moment from 'vue-moment'
import VueClipboard from 'vue-clipboard2'

import { AxiosPlugin } from '@/plugins/axiosPlugin'
import { SignalHubPlugin } from '@/plugins/signalHubPlugin'
import ToastPlugin from '@/plugins/toastPlugin'
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import VueQuillEditor from 'vue-quill-editor'
import CKEditor from 'ckeditor4-vue'
// import { StripePlugin } from '@vue-stripe/vue-stripe'

// Argon
// Polyfills for js features used in the Dashboard but not supported in some browsers (mainly IE)
import '@/polyfills';
// Sidebar on the right. Used as a local plugin in DashboardLayout.vue
import SideBar from '@/components/BaseArgon/SidebarPlugin';

for (const [rule, validation] of Object.entries(rules)) {
  extend(rule, {
      ...validation
  })
}

const options = {
  pk: process.env.STRIPE_PUBLISHABLE_KEY,
  stripeAccount: process.env.STRIPE_ACCOUNT,
  apiVersion: process.env.API_VERSION,
  locale: process.env.LOCALE,
}

Vue.config.productionTip = false
Vue.use(VueQuillEditor, {
    theme: 'snow',
    placeholder: 'Enter description...',
    modules: {
        toolbar: [
            ['bold', 'italic', 'underline'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['link', 'image']
        ]
    }
})
Vue.use(BootstrapVue, {
  BToast: {
    toaster: 'b-toaster-bottom-right'
  }
})
Vue.use(IconsPlugin)
Vue.use(AsyncComputed)
Vue.use(VueClipboard)
Vue.use(AxiosPlugin)
Vue.use(SignalHubPlugin)
Vue.use(ToastPlugin)
Vue.use(moment)
Vue.use(CKEditor)
// Argon
Vue.use(SideBar);
//Vue.use(StripePlugin, options)
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)
Vue.component(Table.name, Table)
Vue.component(TableColumn.name, TableColumn)
Vue.component(Dropdown.name, Dropdown)
Vue.component(DropdownItem.name, DropdownItem)
Vue.component(DropdownMenu.name, DropdownMenu)
Vue.mixin(NavbarScrollMixin)
Vue.prototype.appConfig = config
Vue.prototype.$customConfirm = customConfirm;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
